var _classCallCheck = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/createClass");

var DOMPurify = require('dompurify');

var DEFAULT_CONFIG = require('./DEFAULT');

var XssFilter =
/*#__PURE__*/
function () {
  "use strict";

  function XssFilter() {
    _classCallCheck(this, XssFilter);

    this.config = DEFAULT_CONFIG;
  }
  /**
   * Overrides config object
   * @param {object} config A config object for xss package.
   */


  _createClass(XssFilter, [{
    key: "setConfig",
    value: function setConfig(config) {
      this.config = config;
    }
    /**
     * Overrides one property in config object
     * @param {string} name A name of property in config.
     * @param {any} value A property value.
     */

  }, {
    key: "setConfigProperty",
    value: function setConfigProperty(name, value) {
      this.config[name] = value;
    }
    /**
     * Filter html to prevent xss attack
     * @param {string} html A html which need to be filtered
     * @param {object=} config [optional] Property with config of xss package, if
     *      not exist, used config property from class. 
     */

  }, {
    key: "filter",
    value: function filter(html) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.config;
      return DOMPurify.sanitize(html, config);
    }
  }]);

  return XssFilter;
}();

module.exports = new XssFilter();